import { Component, Input } from '@angular/core';
import {
  CardModule,
  CheckboxModule,
  DropdownModule,
  RadioButtonModule,
  AlertModule,
  TooltipModule,
} from 'axis-components';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormGroup } from '@angular/forms';
import { BaseRules, TextValues } from './delaware.model';
import { PipBaseStateComponent } from '../pip-base-state.component';
import { AdditionalOptions, PersonalInjuryProtectionSelection } from '../../../config/pip-constants';
import { TruncateModule } from 'axis-components/truncate';

@Component({
  selector: 'app-delaware',
  standalone: true,
  imports: [
    CardModule,
    CheckboxModule,
    DropdownModule,
    ReactiveFormsModule,
    RadioButtonModule,
    AlertModule,
    CommonModule,
    TruncateModule,
    TooltipModule
  ],
  templateUrl: './delaware.component.html',
  styleUrl: './delaware.component.scss',
})
export class DelawareComponent extends PipBaseStateComponent<
  BaseRules,
  TextValues
> {
  @Input() set formGroup(form: FormGroup | null) {
    if (form) {
      super.getJsonRuleFiles('delaware', form);
    }
  }
  @Input() set isReview(review: boolean) {
    if (review) {
      super.getJsonRuleFiles('delaware', null);
    }
  }

  override dynamicRuleQueryBuilder(): string {
    if (
      this.baseRulesService.additionalOptions ===
      AdditionalOptions.RejectAdditionalPIP || this.baseRulesService.personalInjuryProtectionSelection ===
      PersonalInjuryProtectionSelection.RejectWherePermissible
    ) {
      return 'ShowPartial';
    }
if (
      ((this.baseRulesService.personalInjuryProtectionSelection ===
        PersonalInjuryProtectionSelection.IndividualStateCoverage ||
        this.baseRulesService.personalInjuryProtectionSelection ===
        PersonalInjuryProtectionSelection.AcceptCoverage) &&
        (this.baseRulesService.additionalOptions ===
          AdditionalOptions.AcceptAdditionalPIP ||
          this.baseRulesService.additionalOptions ===
          AdditionalOptions.VaryByState))
    ) {
      return 'ShowAll';
    }
  }
}
